function parseTimeToMinutes(value) {
  const raw = String(value || '').trim();
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(raw);
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
}

export function isValidTimeHhMm(value) {
  return parseTimeToMinutes(value) != null;
}

export function hoursBetween(startTime, endTime) {
  const start = parseTimeToMinutes(startTime);
  const end = parseTimeToMinutes(endTime);
  if (start == null || end == null || end <= start) return null;
  return (end - start) / 60;
}

export function roundHours(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 1000) / 1000;
}

/**
 * Preview net hours using current org preferences (mirrors server compute).
 * TIME_RANGE with only startTime → { hours: 0 }. Missing/invalid start → null.
 */
export function previewNetHours({ hours, startTime, endTime, usedLunch }, prefs) {
  const format = prefs?.dailyWorkHoursFormat === 'TIME_RANGE' ? 'TIME_RANGE' : 'HOURS';
  let gross = null;
  if (format === 'TIME_RANGE') {
    if (!isValidTimeHhMm(startTime)) return null;
    const endRaw = endTime != null && String(endTime).trim() ? String(endTime).trim() : '';
    if (!endRaw) {
      return { gross: 0, reduction: 0, hours: 0 };
    }
    gross = hoursBetween(startTime, endTime);
    if (gross == null) return null;
  } else {
    const parsed = parseFloat(hours);
    gross = Number.isFinite(parsed) ? parsed : null;
  }
  if (gross == null || gross < 0) return null;

  const lunchMinutes = Number(prefs?.lunchDurationMinutes);
  const lunchHours = Number.isFinite(lunchMinutes) && lunchMinutes > 0 ? lunchMinutes / 60 : 0;
  const reduce = Boolean(usedLunch) && !prefs?.lunchIsPartOfWorkHours && lunchHours > 0;
  const reduction = reduce ? lunchHours : 0;
  return {
    gross: roundHours(gross),
    reduction: roundHours(reduction),
    hours: Math.max(0, roundHours(gross - reduction)),
  };
}

export function formatTimeRange(startTime, endTime) {
  if (!startTime && !endTime) return '';
  if (startTime && !endTime) return `${startTime}–—`;
  if (!startTime && endTime) return `—–${endTime}`;
  return `${startTime}–${endTime}`;
}
